import { Fragment } from "react";
import DocumentUploadModal from "../../../../../../components/ui/forms/DocumentUploadModal";
import DependentModal from "../../../../../../components/ui/popup/popups/DependentModal";
import ConfirmationModal from "../../../../../../components/ui/popup/ConfirmationModal";
import GenerateGainLossModal from "../GenerateGainLossModal";
import Sign8879Modal from "../Sign8879Modal";
import Prepare8879ErrorModal from "../Prepare8879ErrorModal";
import CpaAcceptedFilingModal from "../CpaAcceptedFilingModal";
import EfileStateUpdateModal from "../EfileStateUpdateModal";
import SignAuthErrorModal from "../SignAuthErrorModal";
import RequestSignatureModal from "../RequestSignatureModal";
import DemoWelcomeModal from "../DemoWelcomeModal";
import CustomerReviewModal from "../CustomerReviewModal";
import CpaCompletionModal from "../CpaCompletionModal";
// Import all 14 modals here...

function FilingModalOrchestrator({
  ui,
  state,
  data,
  actionsDocument,
  actionsDependent,
  isCpa,
  filingUuid,
  taxYearsArray,
  setFiling,
}) {
  const {
    isUploadModalOpen,
    selectedSource,
    selectedDocumentId,
    isDependentModalOpen,
    showDeleteConfirmation,
    deleteDependentIndex,
    showEnableUploadConfirmation,
    showGenerateGainLossModal,
    isSigningModalOpen,
    show8879PrepareModal,
    showAcceptedPopup,
    showEfileStateUpdateModal,
    efileStateUpdateService,
    efileStateUpdateNumber,
    showSignAuthModal,
    showRequestSignatureModal,
    showDemoWelcomeModal,
    showCusReviewIntroModal,
    showCusReviewModal,
    showProcessCompleteModal,
    // Add these if they are in modalState
    setShowGenerateGainLossModal,
    setIsSigningModalOpen,
    setShowAcceptedPopup,
    setShowEfileStateUpdateModal,
    setShowDemoWelcomeModal,
    setShowCusReviewIntroModal,
    setShowCusReviewModal,
    setShowProcessCompleteModal,
  } = state;

  // --- 2. Destructure data (lists and entities) ---
  const { filing, dependents } = data;

  // --- 3. Destructure UI Handlers (functions) ---
  const {
    handleCloseUploadModal,
    handleUploadSuccess,
    handleUploadError,
    handleCloseDependentModal,
    handleCancelDeleteDependent,
    handleCancelEnableCryptoUpload,
    handleConfirmEnableCryptoUpload,
    handleCloseGenerateGainLossModal,
    onGenerateGainLossSubmit,
    handleEfileSignatureCompleted,
    handleClose8879PrepareModal,
    handleEfileStateUpdate,
    handleCloseSignAuthModal,
    handleCloseRequestSignatureModal,
  } = ui;

  // --- 4. Destructure Action Handlers ---
  const { handleUploadDocument } = actionsDocument;
  const {
    handleSubmitDependent,
    handleConfirmDeleteDependent,
    editingDependentIndex,
  } = actionsDependent;

  const {
    handlePrepare8879,
    prepare8879Error,
    signAuthError,
    handleSignAuthorization,
    handleRequestSignature,
    isRequestingSignature,
    requestSignatureError,
    requestSignatureSuccess,
  } = state.filingActions || {};

  const handleConfirmDeleteAndClose = async () => {
    // handleConfirmDeleteDependent is returned by useDependentActions
    // and returns true on success
    const success = await handleConfirmDeleteDependent();

    if (success) {
      handleCancelDeleteDependent(); // This is your close/reset function
    }
  };

  return (
    <Fragment>
      <DocumentUploadModal
        isOpen={isUploadModalOpen}
        onClose={handleCloseUploadModal}
        onUploadSuccess={handleUploadSuccess}
        onUploadError={handleUploadError}
        uploadFunction={handleUploadDocument}
        title={
          selectedSource ? `Upload ${selectedSource.label}` : "Upload Document"
        }
        allowedFileTypes={
          selectedSource?.name === "cryptoTransaction" &&
          selectedSource?.documentType === "transactions"
            ? [
                "text/csv",
                "application/csv",
                "text/comma-separated-values",
                "application/vnd.ms-excel",
              ]
            : null
        }
        allowedExtensions={
          selectedSource?.name === "cryptoTransaction" &&
          selectedSource?.documentType === "transactions"
            ? [".csv"]
            : null
        }
        selectedSource={selectedSource}
        selectedDocumentId={selectedDocumentId}
        taxYears={
          selectedSource?.name === "cryptoTransaction" &&
          selectedSource?.documentType === "transactions"
            ? (() => {
                const ptfTaxYears =
                  filing.tax_situation?.details?.PTF?.situation?.taxYears;
                const btfTaxYears =
                  filing.tax_situation?.details?.BTF?.situation?.taxYears;
                const taxYears = ptfTaxYears || btfTaxYears;
                if (Array.isArray(taxYears)) {
                  return taxYears;
                } else if (taxYears) {
                  return [taxYears];
                }
                return [];
              })()
            : null
        }
      />

      <DependentModal
        isOpen={isDependentModalOpen}
        onClose={handleCloseDependentModal}
        onSubmit={handleSubmitDependent}
        dependent={
          editingDependentIndex !== null
            ? dependents[editingDependentIndex]
            : null
        }
      />

      <ConfirmationModal
        isOpen={showDeleteConfirmation}
        onClose={handleCancelDeleteDependent}
        onConfirm={handleConfirmDeleteAndClose}
        title="Delete Dependent"
        message={`Are you sure you want to delete this dependent? ${
          deleteDependentIndex !== null && dependents[deleteDependentIndex]
            ? `\n\n${dependents[deleteDependentIndex].firstname} ${dependents[deleteDependentIndex].lastname}\n\nThis action cannot be undone.`
            : ""
        }`}
        confirmText="Delete"
        cancelText="Cancel"
        confirmButtonClass="primary"
        cancelButtonClass="secondary"
      />

      <ConfirmationModal
        isOpen={showEnableUploadConfirmation}
        onClose={handleCancelEnableCryptoUpload}
        onConfirm={handleConfirmEnableCryptoUpload}
        title="Enable Upload"
        message="Are you sure you want to enable uploads? This action will delete any Gain & Loss generated for your crypto transactions. This action cannot be undone."
        confirmText="Enable"
        cancelText="Cancel"
        confirmButtonClass="primary"
        cancelButtonClass="secondary"
      />

      {/* Generate Gain & Loss Modal */}
      <GenerateGainLossModal
        isOpen={showGenerateGainLossModal}
        onClose={() => setShowGenerateGainLossModal(false)}
        taxYears={taxYearsArray} // Now this variable is defined!
        onGenerate={onGenerateGainLossSubmit}
      />

      {/* E-Signature Modal for Form 8879 */}
      <Sign8879Modal
        isOpen={isSigningModalOpen}
        onClose={() => setIsSigningModalOpen(false)}
        onCompleted={handleEfileSignatureCompleted}
      />

      {/* Prepare 8879 Modal - Shows error only */}
      <Prepare8879ErrorModal
        isOpen={show8879PrepareModal}
        error={prepare8879Error}
        onClose={handleClose8879PrepareModal}
        onRetry={handlePrepare8879}
      />

      {/* CPA Accepted Filing Popup - Shows recommendation to message taxpayer */}
      <CpaAcceptedFilingModal
        isOpen={showAcceptedPopup}
        onClose={() => setShowAcceptedPopup(false)}
        filingUuid={filingUuid}
      />

      <EfileStateUpdateModal
        isOpen={showEfileStateUpdateModal}
        onClose={() => setShowEfileStateUpdateModal(false)}
        service={efileStateUpdateService}
        initialNumber={efileStateUpdateNumber}
        onUpdate={handleEfileStateUpdate}
      />

      <SignAuthErrorModal
        isOpen={showSignAuthModal}
        error={signAuthError}
        onClose={handleCloseSignAuthModal}
        onRetry={handleSignAuthorization}
      />

      {/* Request Signature Modal - Confirmation, Loading, Success, Error states */}
      <RequestSignatureModal
        isOpen={showRequestSignatureModal}
        onClose={handleCloseRequestSignatureModal}
        onConfirm={handleRequestSignature}
        isLoading={isRequestingSignature}
        error={requestSignatureError}
        success={requestSignatureSuccess}
      />

      {/* Demo Welcome Modal for CUS */}
      {!isCpa && (
        <DemoWelcomeModal
          isOpen={showDemoWelcomeModal}
          onClose={() => setShowDemoWelcomeModal(false)}
        />
      )}

      {/* CUS Review Intro Modal - Step 1: Soft ask for feedback */}
      {!isCpa && (
        <CustomerReviewModal
          showIntro={showCusReviewIntroModal}
          showQuestions={showCusReviewModal}
          filingUuid={filingUuid}
          setFiling={setFiling}
          onClose={() => {
            setShowCusReviewIntroModal(false);
            setShowCusReviewModal(false);
          }}
          onTransitionToQuestions={() => {
            setShowCusReviewIntroModal(false);
            setShowCusReviewModal(true);
          }}
        />
      )}

      {/* CPA Completion Modal (Non-Demo) */}
      {isCpa && (
        <CpaCompletionModal
          isOpen={showProcessCompleteModal}
          onClose={() => setShowProcessCompleteModal(false)}
        />
      )}
    </Fragment>
  );
}

export default FilingModalOrchestrator;
